import { authHelper } from './authHelper'

export const getPcekZone = () => {
  const isAuth = authHelper.isAuthenticated()

  return isAuth ? 'b' : 'anonymous'
}
